const loginAndSignUp = {
  loginTips: "HitPaw 계정이 이미 있을까? <1>로그인</1>",
  loginSuccessTips: "로그인에 성공했습니다.",
  loginErrorTips: "로그인에  실패했습니다.",
  loginAccountOrPasswordErrorTips: "이메일 주소나 비밀번호가 틀렸습니다. 다시 시도하십시오.",
  loginAccountNotExitErrorTips: "이메일이 등록되지 않았습니다.",
  signUpTips: "아직 등록된 사용자가 아니신가요? ",
  rememberMe: "비밀번호 저장",
  forgotPassword: "비밀번호를 잊으셨습니까?",
  forgotPasswordTitle: "비밀번호 잊어버림",
  verifyEmailBtn: "이메일 확인하기",
  resetPasswordTitle: "비밀번호 재설정하기",
  resetPasswordLabel: "비밀번호를 재설정하십시오.",
  resetPasswordPlaceholder: "새 비밀번호 입력하기",
  resetPasswordSuccessTips: "비밀번호 재설정 성공했습니다.",
  signUpPrivacyTips: "회원가입을 통해 귀하는 당사의 <1>사용 서비스 </1> 및 <3>개인 정보 보호 정책</3>에 동의하는 것입니다.",
  loginPrivacyTips: "로그인하면  귀하는 당사의 <1>사용 서비스</1> 및 <3>개인 정보 보호 정책</3>에 동의하는 것입니다.",
  signUpSuccessTips: "계정이 성공적으로 등록되었습니다!",
  getCode: "인증번호 가져오기",
  getCodeSuccessTips: "우편함으로 보내졌으니 확인해 주세요.",
  verificationSuccessTips: "이메일 확인했습니다.",
  surveyTitle: "HitPaw Online 바로 시작합시다!",
  surveyStep1: "<1>1단계</1>",
  surveyStep2: "<1>2단계</1>",
  surveyStep3: "<1>3단계</1>",
  surveyQuestion: "HitPaw를 사용하는 목적은 무엇입니까?",
  surveyThemeQuestion: "원하는 모드를 선택하십시오.",
  surveyAnswerOther: "다른",
  surveyAnswer1: "라이프스타일 비디오",
  surveyAnswer2: "비즈니스 비디오",
  surveyAnswer3: "회사 비디오",
  surveyAnswer4: "마케팅 비디오",
  surveyAnswer5: "소셜 미디어 비디오",
  surveyAnswer6: "슬라이드쇼 비디오",
  surveyAnswer7: "비디오 도구",
  surveyAnswer8: "여행 비디오",
  surveyAnswer9: "웨딩 비디오",
  surveyAnswer10: "생일 비디오",
  surveyAnswer11: "아기 비디오",
  surveyAnswer12: "동물 비디오",
  surveyAnswer13: "푸드 비디오",
  surveyAnswer14: "패션 비디오",
  surveyAnswer15: "휴일 비디오",
  surveyAnswer16: "스포츠 비디오",
  surveyAnswer17: "사진 비디오",
  surveyAnswer18: "뮤직 비디오",
  surveyAnswerLightMode: "라이트 모드",
  surveyAnswerDarkMode: "다크 모드",
  surveyNextBtn: "다음",
  surveyBackBtn: "뒤로",
  surveyDoneBtn: "완료",
  surveyStartBtn: "시작하기",
  logoutWarnTips: "로그아웃하시겠습니까?",
};

export default loginAndSignUp;
